import { http } from '@/services/http'
import queryBuilder from '@/services/queryBuilder'

const pagination = [
  'total_pages',
  'next_page',
  'previous_page',
  'total_records',
  'post_per_page'
]

const accountStructure = {
  id: true,
  confirmation_date: true,
  email: true,
  payments: {
    saldo: true
  },
  calculations: {
    started: true,
    completed: true,
    phone_confirmed: true,
    sold_policies: true
  }
}

const detailsUserStructure = {
  id: true,
  first_name: true,
  last_name: true,
  email: true,
  phone: true,
  website_url: true,
  website: true,
  social_media: true,
  marketing: true,
  email_marketing: true,
  payments_info: {
    account_type: true,
    company_name: true,
    nip: true,
    pesel: true,
    bank_account: true,
    street_name: true,
    street_number: true,
    city: true,
    zip_code: true
  },
  tranches_info: {
    token: true,
    amount: true,
    created_at: true
  },
  settlement: {
    cps: true,
    cpl: true
  }
}

const getList = ({ state, commit }, pageNumber = 1) => {
  commit('PENDING', true)
  return new Promise((resolve, reject) => {
    const query = {
      query: queryBuilder.buildQuery({
        partners: {
          where: {
            page: pageNumber
          },
          select: {
            accounts: accountStructure,
            pagination: pagination
          }
        }
      })
    }

    http
      .get('/api/graphql', { params: query })
      .then(response => {
        commit('SAVE_LIST', response.data)
        resolve(response)
      })
      .catch(error => {
        commit('PENDING', false)
        reject(error.response.data)
      })
  })
}

const findBy = ({ state, commit }, condition) => {
  commit('PENDING', true)
  return new Promise((resolve, reject) => {
    const query = {
      query: queryBuilder.buildQuery({
        partners: {
          where: condition,
          select: {
            accounts: accountStructure,
            pagination: pagination
          }
        }
      })
    }

    http
      .get('/api/graphql', { params: query })
      .then(response => {
        commit('SAVE_SEARCH', response.data)
        resolve(response)
      })
      .catch(error => {
        commit('PENDING', false)
        reject(error.response.data)
      })
  })
}

const findOne = ({ state, commit }, condition) => {
  commit('PENDING', true)
  return new Promise((resolve, reject) => {
    const query = {
      query: queryBuilder.buildQuery({
        account: {
          where: condition,
          select: detailsUserStructure
        }
      })
    }

    http
      .get('/api/graphql', { params: query })
      .then(response => {
        commit('SAVE_SINGLE', response.data)
        resolve(response)
      })
      .catch(error => {
        commit('PENDING', false)
        reject(error.response.data)
      })
  })
}

export default {
  getList,
  findBy,
  findOne
}



// WEBPACK FOOTER //
// ./src/store/modules/users/actions.js